export default {
  // Sverige / Svenska se 스웨덴어
  LandingPage: {
    intro_sub:
      'Ge förpackningen ett nytt liv',
    title: 'Samsungs förpackningar',
    sequence1_1: 'Hitta nya användningsområden till förpackningen',
    sequence1_2:
      'Skapa nya produkter av din produkt:s föpackning. Bläddra ner för att se hur du gör.',
    sequence2_1: 'Låt oss presentera: Samsungs nya förpackningar',
    sequence2_2:
      'En TV-förpackning som är utformad för att "upcyclas", alltså för att skapa nya produkter av förpackningen.',
    sequence3_1: 'Följ punkterna på förpackningen',
    sequence3_2:
      'Klipp förpackningen enligt instruktionerna och montera till en ny produkt!',
    sequence4_1: 'Välj vilken produkt du vill göra',
    sequence4_2:
      'Bläddra ner och välj vilken modell du har. Välj sedan mellan de olika designvalen och börja skapa en helt ny produkt av förpackningen.',
    selectBox: 'Välj din produkt',
    moreActivity:
      "Mer information om Samsungs aktiviteter",
    OLED: 'OLED',
    QLED8K: 'QLED', //update
    UHD: 'UHD', //update
    FHD: 'FHD',
    HD: 'HD',
    theFrame: 'The Frame', //update
    theSerif: 'The Serif', //update
    theSero: 'The Sero', //update
    theTerrace: 'The Terrace', //update
    thePremiere: 'The Premiere', //update
    Monitors: 'Monitors', //update
    OdysseyArk:"Odyssey Ark",
    QSoundbar: 'Q Soundbar', //update
    Soundbar: 'Soundbar', //update
    SoundbarSet01:'Soundbar Set 1',
    SoundbarSet02:'Soundbar Set 2',
    TheTerraceSoundbar:'The Terrace Soundbar',
    Soundtower:'Sound Tower',
    BespokeJet: 'BESPOKE Jet\n (Jet)',
    BespokeJetStation:'BESPOKE Jet\n (Clean Station™)',
    BespokeJetNCleanStation : 'BESPOKE Jet&\nClean Station™',
    BespokeJetNCleanStation2 : 'BESPOKE Jet&Clean Station™',
    BespokeCube53:'BESPOKE Cube™ AIR\n(53㎡)',
    BespokeCube70:'BESPOKE Cube™ AIR\n(70㎡)',
    BespokeCube106:'BESPOKE Cube™ AIR\n(106㎡)',
    BespokeCube123:'BESPOKE Cube™ AIR\n(123㎡)',
    Qooker:'Qooker',
    BespokeSlim:'BESPOKE \nSlim',
    TheFreeStyle:"The Freestyle",
    BespokeSlimCleanStation:"BESPOKE Slim&Jet\n(Clean Station™)",
    JetCleanStation:"Jet&\nClean Station™",
    JetCleanStation2:"Jet&Clean Station™",
    BlueSky:"BlueSky \n5500",
    BlueSky3000:"BlueSky \n3000",
    BlueSky3100:"BlueSky \n3100",
    BlueSky5000:"BlueSky \n5000",
    BespokeJetbot:"BESPOKE\n Jet Bot",
    BespokeJetbot2:"BESPOKE Jet Bot",
    BespokeJetbotPlus:"BESPOKE\n Jet Bot+",
    BespokeJetbotPlus2:"BESPOKE Jet Bot+",
    BespokeJetbotAI:"BESPOKE\n Jet Bot AI",
    BespokeJetbotAI2:"BESPOKE Jet Bot AI",
    Canister01:"Canister \n01",
    Canister02:"Canister \n02",
    Jupiter:"Vacuum \nCleaner",
    ref_cube:"BESPOKE Cube",
    WaterPurifier:"Water Purifier",
    LATIN:"LATIN",
    LATIN10:"LATIN10",
    MIRROR:"MIRROR",
    MW5100J:"MW5100J",
    STENA:"STENA",
    // moreActivityLink:
    //   'https://www.samsung.com/us/sustainability/overview/',
    // moreActivityLink:'https://www.samsung.com/se/aboutsamsung/sustainability/strategy/',
    moreActivityLink: 'https://www.samsung.com/se/sustainability/overview/',
    footer: `
    copyright© 2019-2021 SAMSUNG All Rights Reserved.`,
  },
  ProductPage: {
    selectDesign: 'Välj vilken produkt du vill göra',
    selectDesignDezeen: 'Samsung X Dezeen', //update
    selectDesignSoccer: 'Samsung X Football', 
    tvConsole: 'TV-konsol',
    StorageBox: 'Förvaringslåda',
    MagazineRack: 'Tidningshylla',
    CatHouse: 'Katthus',
    CatTunnel: 'Kattunnel',
    BookShelf: 'Bokhylla',
    DeskShelf: 'Skrivbordshylla',
    BlackRhino: 'Utrotningshotade\n djur Svart\n noshörning', //update
    PolarBear: 'Utrotningshotade\n djur\n Isbjörn', //update
    SeaTurtle: 'Utrotningshotade\n djur\n Sköldpadda', //update
    TheRider: 'Gunghäst', //update
    Kibe: 'Kibe', //update
    Tessellate: 'Tessellationhylla', //update
    Twist: 'Twist-låda', //update
    AlexCouchArmTable: 'Alex-bord\n för armstöd', //update
    BlastOffClubHouse: 'Rakethus', //update
    KinokoTable: 'Kinoko-bord', //update
    Magnuss: 'Magnuss-förvaringshylla', //update
    GIO: 'Kruka', //update
    PostCardPlanter: 'Vykortshållare', //update
    SneakerRack: 'Skohylla', //update
    TheSoban: 'Receptbokshållare', //update
    ToolBox: 'Verktygslåda', //update
    DeskStationary: 'Skrivbordsställ',
    CoinBank: 'Spargris',
    MobileScanner:'Ställning för skanning med mobil',
    TabletScanner:'Ställning för skanning med surfplatta',
    PetStairs:'Husdjurtrappor',
    PetFurniture: 'Pet Friendly Furniture',
    ShoeRackA:'Shoe Rack_A',
    ShoeRackB:'Shoe Rack_B',
    WineRackDog:'Wine Rack Dog',
    WineRack:'Wine Rack',
    mins: 'minuter',
    all:'ALL',
    in: 'i',
    inOnly: 'i endast',
    allBoxSize: 'Alla kartongstorlekar',
    soccergoalpost:'Mini Soccer Goal Post',
   soccerboard:'Table Soccer Board',
   sixpackcarrier:'Six Pack Carrier',
   trophytable:'Trophy Cup Table',
   megaphone:'Cheer Megaphone',
   FreestyleBear:'Small \n Animals \n Polar Bear',
   FreestyleRay:'Small \n Animals \n Ray',
   FreestyleRhino:'Small \n Animals \n Black Rhino',
   FreestyleSeahorse:'Small \n Animals \n See Horse',
   FreestyleWhale:'Small \n Animals \n Whale',
   Mickey:'Mickey Mouse',
   Pluto:'Pluto',
   Diseny:'Samsung X Disney'
  },
  DetailGuidePage: {
    1:'1',
    2:'2',
    3:'3',
    instructions: 'instruktioner',
    prepare: 'Förbered förpackningen',
    LetsDesign: "Låt oss designa",
    drawParts: 'Rita delar på förpackningen',
    note1: 'Notera att den grafiska positionen kan variera beroende på land och storlek',
    note2: 'Rita hela ritningen först för att säkerställa att den får plats på förpackningen',
    numberSpace: 'nummer = avstånd mellan prickar',
    diagonal: 'diagonal',
    LEFT: 'VÄNSTER',
    RIGHT: 'HÖGER',
    TOP: 'TOPP',
    TOP1: 'TOPP 1',
    TOP2: 'TOPP 2',
    BACK: 'BAK',
    MIDDLE: 'MITTEN',
    MIDDLE2: 'MITTEN 2',
    BOTTOM: 'BOTTEN',
    FRONT: 'FRAM',
    SIDE: 'SIDA',
    secondSIDE: 'ANDRA SIDAN',
    secondSIDE1: 'ANDRA SIDAN 1',
    secondSIDE2: 'ANDRA SIDAN 2',
    LEG: 'BEN', //update
    JOINT: 'SKARV', //update
    FACE: 'ANSIKTE', //update
    DRAWERBOTTOM: 'LÅDANS BOTTEN', //update
    DRAWERSIDE: 'LÅDANS SIDA', //update
    NOSE: 'NÄSA', //update
    HANDLE: 'HANDTAG', //update
    BOTTOMSIDE: 'BOTTENSIDA', //update
    TOPSIDE: 'TOPPSIDA', //update
    WING: 'VINGE', //update
    cutAndAssemble: "Dags att klippa och montera",
    beCareful: 'Var försiktig så du inte skär dig när du klipper',
    cutOutParts: 'Klipp ut delar',
    assemble: 'Montera',
    Assemblyguide: 'Monteringsguide', //update
    fold: 'Exempel på vikning',
    foldGuide: 'Använd kanten på produkten när du viker kartongen',
    foldGuideDezeen:
      'Tryck på den prickade linjen på förpackningen några gånger för att underlätta när förpackningen ska vikas', //update
    glue: 'Applicera lim eller tejp jämt på ytan', //update
    cable: 'Använd exempelvis buntband för att fästa ihop delarna', //update
    done: 'Klar!',
    goBack: 'Tillbaka till huvudmenyn',
  },
  CautionPage: {
    CAUTION: 'VARNING',
    needItem: 'Du behöver dessa objekt',
    children: 'Barn ska vara i vuxet sällskap',
    mat:
      'Lägg ett skydd på golvet för att förhindra repor',
    doNotPutHeavyThing:
      'Stig eller sitt inte på dessa möbler och lägg inte tunga saker på dem',
    doNotThrow:
      'Släng eller sparka inte möblerna mot något eller någon, inklusive människor och djur',
    stayAwayFlame: 'Håll borta från lågor och eld',
    stayAwayWater: 'Håll borta från vatten och fukt',
    mayDamaged: '* förpackningen kan skadas under leverans',
    companyDoestResponsible:
      '* Företaget tar inte ansvar för olyckor eller skador under detta arbete',
    cannotBeReturned:
      '* Produkter med skadade förpackningar kan ej returneras på grund av kvalitetsfrågor',
    understand: 'OK, jag förstår',
  },
  PrivacyPolicy: {
    title: 'Integritetspolicy',
  },
  GoingGreen: {
    visual: {
      title: 'Våra innovationer inom förpackning',
      text1:
        'Vi strävar efter att använda mindre papper och bläck i de flesta av våra TV-förpackningar, jämfört med våra tidigare förpackningar. ',
      text2:'',
      text2_special:
        '(* Ovan gäller inte för vissa modeller, inklusive Lifestyle-TV)',
      text3: 'Välj knapp nedan för att lära dig mer',
    },
    greenIn: {
      title: 'Nya förpacknigsinnovationer',
      subtitle1: 'Sök produktinformation',
      subtitle2: 'Upcycling av förpacknignar',
      desc: 'Sök på modellnamn för att läsa mer',
      descM: '*Ta ett foto på TV-modellnumret',
      guide: 'modellnamn',
      button: 'Ta ett foto',
      button2: 'Gå till Skapa produkter',
      product_info: 'Produktinformation',
    },
    search: {
      guide: 'Sök..',
      noResult: 'Inga resultat',
      more: 'MER',
      search: 'Sök',
      retake: 'Gör om',
      result: 'Resultat',
    },
    photo: {
      guide1: 'Placera TV-modellnamnet i förpackningen',
      guide2: '(t.ex. Q800A, UT7000, RU710)',
    },
  },
  searchCountrySelect: 'Välj land för att söka'
};
